import BaseDataProcessor from './baseDataProcessor';
import moment from 'moment-timezone';
import pluralize from 'pluralize';

pluralize.addPluralRule(/^IAK$/, 'IAK-s');

export default class GuestCardActivitiesDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData, interval) {
    super();

    this.apiStatisticsData = apiStatisticsData;
    this.interval = interval;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      const { guestsTotal, guestsForPeriod, guestsApplicableForInvite, iaksSubmitted, iaksSubmittedDelta } =
        this.apiStatisticsData;

      return [
        { primaryText: guestsTotal, secondaryText: 'guest cards total' },
        this.guestsForPeriodItem(guestsForPeriod),
        { primaryText: iaksSubmitted, secondaryText: 'IAK-s' },
        this.iaksSubmittedDeltaItem(iaksSubmittedDelta),
        this.applicableForInviteItem(guestsTotal, guestsApplicableForInvite)
      ].filter(item => item);
    } else {
      return [];
    }
  }

  get byTypeChartData() {
    if (this.apiStatisticsData) {
      const { iaksByTypeDistribution } = this.apiStatisticsData;

      return iaksByTypeDistribution.map((item) => ({ x: item.iak.name, y: item.count }))
                                   .sort((itemA, itemB) => itemA.y - itemB.y);
    } else {
      return [];
    }
  }

  get byDayChartData() {
    if (this.apiStatisticsData) {
      const { iaksByDayDistribution } = this.apiStatisticsData;

      return iaksByDayDistribution.map((item) => ({ x: this.xValueByDay(moment.unix(item.intervalStart)), y: item.count }));
    } else {
      return [];
    }
  }

  get byDayBarTooltip() {
    if(this.interval === 'all time') {
      return (datum) => `${datum.x}\n${this.iaksLabel(datum)}`;
    } else {
      return this.iaksLabel;
    }
  }

  get iaksLabel() {
    return (datum) => pluralize('IAK', datum.y, true).split('-')
      .map((part, index) => index === 1 ? part.toLowerCase() : part).join('-');
  }

  guestsForPeriodItem(guestsForPeriod) {
    if(guestsForPeriod != null) {
      return {
        primaryText: this.decorateDeltaValue(guestsForPeriod, BaseDataProcessor.SIGN_TYPE_SIGN, true),
        secondaryText: this.decorateDeltaText(guestsForPeriod, this.interval, true)
      };
    } else {
      return null;
    }

  }

  iaksSubmittedDeltaItem(delta) {
    if(delta != null) {
      return {
        primaryText: this.decorateDeltaValue(delta, BaseDataProcessor.SIGN_TYPE_ARROW),
        secondaryText: this.decorateDeltaText(delta, this.interval)
      }
    } else {
      return null;
    }
  }

  applicableForInviteItem(guestsTotal, guestsApplicableForInvite) {
    if(guestsApplicableForInvite != null) {
      return { primaryText: `${guestsApplicableForInvite}/${guestsTotal}`, secondaryText: 'guests can be invited' };
    } else {
      return null;
    }
  }

  xValueByDay(value) {
    if(this.interval === 'all time' ) {
      return value.format('MMM DD');
    } else if(this.interval === 'week') {
      return value.format('ddd');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/guestCardActivitiesDataProcessor.js